export const getAssignedEntityText = (isVacant, shiftStatus, entityDisplayName) => {
    const assignedEntityName = isVacant ? 'Vakant' : entityDisplayName !== null && entityDisplayName !== void 0 ? entityDisplayName : 'Okänd';
    const text = shiftStatus == 'WITHDRAWN' ? `Inställt (${assignedEntityName})` : assignedEntityName;
    return text;
};
export default getAssignedEntityText;
